import * as api from "./api";

export async function callerData(dashboardId = "") {
  const urlParams = new URLSearchParams(location.search);
  let searchParam = location.search;
  let searchQuery = searchParam ? searchParam.replace("?", "") : "";
  const pageSizeParam = urlParams.get("pageSize");
  const assigneeFilter = urlParams.get("assigneeFilter");
  const dashboardIdParam = urlParams.get("dashboardId");
  const result = await api.get(
    `callerData?${searchQuery ? searchQuery : ""}${
      pageSizeParam ? `` : `pageSize=${25}`
    }${assigneeFilter ? `` : `&assigneeFilter=all`}${
      dashboardIdParam ? "" : `&dashboardId=${dashboardId}`
    }`
  );
  return result;
}

export async function callerStatuses(dashboardId = "") {
  const urlParams = new URLSearchParams(location.search);
  let searchParam = location.search;
  let searchQuery = searchParam ? searchParam.replace("?", "&") : "";
  const assigneeFilter = urlParams.get("assigneeFilter");
  const dashboardIdParam = urlParams.get("dashboardId");
  const result = await api.get(
    `callerData?${searchQuery ? searchQuery : ""}${
      assigneeFilter ? `` : `&assigneeFilter=all`
    }${
      dashboardIdParam ? "" : `&dashboardId=${dashboardId}`
    }&showAggregateCount=true&term=status&keyword=status.keyword`
  );
  return result;
}

export async function pendingFollowUps(dashboardId = "") {
  const urlParams = new URLSearchParams(location.search);
  let searchParam = location.search;
  let searchQuery = searchParam ? searchParam.replace("?", "&") : "";
  const assigneeFilter = urlParams.get("assigneeFilter");
  const dashboardIdParam = urlParams.get("dashboardId");
  const result = await api.get(
    `callerData?${searchQuery ? searchQuery : ""}${
      assigneeFilter ? `` : `&assigneeFilter=all`
    }${dashboardIdParam ? "" : `&dashboardId=${dashboardId}`}`
  );
  return result;
}

export async function updateCallerData(id, data) {
  const result = await api.put(`callerData/${id}`, data);
  return result;
}

export async function leadsInBulk(data) {
  const result = await api.put(`callerData/bulk`, data);
  return result;
}

export async function updateDisposition(id, comment) {
  const result = await api.put(
    `disposition/${id}?callerDisposition=${comment}`
  );
  return result;
}

export async function postDisposition(payload) {
  const result = await api.mediaPost(`disposition`, payload);
  return result;
}

export async function getDispositions(id, pageNumber) {
  let searchParam = location.search;
  let searchQuery = searchParam ? searchParam.replace("?", "&") : "";
  const result = await api.get(
    `disposition?${
      searchQuery ? searchQuery : ""
    }&callerDataId=${id}&pageNum=${pageNumber}&pageSize=10`
  );
  return result;
}

export async function myCallingDashboards() {
  const result = await api.get(`calling-dashboard/my`);
  return result;
}

export async function allCallingDashboards() {
  const result = await api.get(`calling-dashboard/all`);
  return result;
}

export async function currentDashboardStatus(dashboardId) {
  const urlParams = new URLSearchParams(location.search);
  let searchParam = location.search;
  let searchQuery = searchParam ? searchParam.replace("?", "&") : "";
  const dashboardIdParam = urlParams.get("dashboardId");
  const result = await api.get(
    `calling-dashboard/status?${searchQuery ? searchQuery : ""}${
      dashboardIdParam ? "" : `dashboardId=${dashboardId}`
    }`
  );
  return result;
}

export async function slashRtc (){
  const result = await api.get(`iframe/dialer`);
  return result;
}